export default __webpack_public_path__ + "static/custom-tooltips-dcafa05743c23344b3c9729decc1a00a.png";